@if (show()) {
<div
  class="border-t border-gray-200 bg-white flex flex-col gap-2 px-4 py-3 lg:h-[4.875rem] lg:flex-row lg:items-center lg:justify-between lg:px-8 lg:py-4 lg:border lg:rounded-lg confirmation-section">
  <!-- Left side: Back and Cancel (stacked full width on compact screens) -->
  <div
    class="flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-4 max-lg:empty:hidden">
    <!-- Back Button (if onBack or backAction provided) -->
    @if (config()?.onBack || config()?.backAction) { @if
    (config()?.backButtonTemplate) {
    <!-- Legacy template support -->
    <ng-container
      [ngTemplateOutlet]="config()?.backButtonTemplate"
      [ngTemplateOutletContext]="{ $implicit: config()?.formData }" />
    } @else {
    <lib-button
      class="max-lg:w-full"
      [id]="titleToId(config()?.title) + '_screen_back_button'"
      [label]="config()?.backButtonText || 'Back'"
      [acknowledgeClick]="true"
      size="lg"
      [disabled]="config()?.backButtonDisabled || false"
      [btnClass]="'bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium text-sm px-4 py-2 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300' + compactButtonClass"
      (click)="handleBackClick()">
    </lib-button>
    } }

    <!-- Cancel Button (if onCancel or secondaryAction provided) -->
    @if (config()?.onCancel || config()?.secondaryAction) {
    <lib-button
      class="max-lg:w-full"
      [id]="titleToId(config()?.title) + '_screen_cancel_button'"
      [label]="config()?.cancelButtonText || config()?.secondaryButtonText || 'Cancel'"
      size="lg"
      [disabled]="config()?.cancelButtonDisabled || false"
      [btnClass]="'text-gray-600 hover:text-gray-800 font-medium text-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-md px-2 py-1' + compactButtonClass"
      (click)="handleCancelClick()">
    </lib-button>
    }
  </div>

  <!-- Right side: Save, Save Edits, and Next buttons (stacked full width on compact screens) -->
  <div class="flex flex-col gap-2 lg:flex-row">
    <!-- Save Button (if onSave provided) -->
    @if (config()?.onSave) {
    <lib-button
      class="max-lg:w-full"
      [id]="titleToId(config()?.title) + '_screen_save_button'"
      [label]="config()?.saveButtonText || 'Save'"
      [acknowledgeClick]="true"
      size="lg"
      [disabled]="config()?.saveButtonDisabled || false"
      [btnClass]="(config()?.saveButtonClass || saveButtonClass) + compactButtonClass"
      (click)="handleSaveClick()">
    </lib-button>
    }

    <!-- Next Button (if onNext or primaryAction provided) -->
    @if (config()?.onNext || config()?.primaryAction) {
    <lib-button
      class="max-lg:w-full"
      [id]="titleToId(config()?.title) + '_screen_next_button'"
      [label]="config()?.nextButtonText || config()?.primaryButtonText || 'Next'"
      [acknowledgeClick]="true"
      size="lg"
      [disabled]="config()?.nextButtonDisabled ?? config()?.primaryButtonDisabled ?? false"
      [btnClass]="(config()?.nextButtonClass || baseButtonClass) + compactButtonClass"
      (click)="handleNextClick()">
    </lib-button>
    }

    <!-- Save Edits Button (if onSaveEdits provided) -->
    @if (config()?.onSaveEdits) {
    <lib-button
      class="max-lg:w-full"
      [id]="titleToId(config()?.title) + '_screen_save_edits_button'"
      [label]="config()?.saveEditsButtonText || 'Save Draft'"
      [acknowledgeClick]="true"
      size="lg"
      [disabled]="config()?.saveEditsButtonDisabled || false"
      [btnClass]="(config()?.saveEditsButtonClass || baseButtonClass) + compactButtonClass"
      (click)="handleSaveEditsClick()">
    </lib-button>
    }

    <!-- Legacy template support (if primaryTemplate provided) -->
    @if (config()?.primaryTemplate) {
    <ng-container
      [ngTemplateOutlet]="config()?.primaryTemplate"
      [ngTemplateOutletContext]="{ $implicit: config()?.formData }" />
    }
  </div>
</div>
}
